import { Toast } from './Commons/Alert/Toast'
import { storeRemissions } from '../services/invoice';
import { buildPayload, restartForm } from '../utils/forms.util';

export const handleSubmit = async (total, customer, services, customerType, clearService, signature, setLoading, setCustomer,) => {
    try {
      setLoading(true);
      const payload = buildPayload({
        total,
        customer,
        services,
        customerType,
        signature
      });
      await storeRemissions(payload);
      clearService();
      restartForm();
      setCustomer("");
      Toast.fire({
        icon: "success",
        title: "Registro guardado exitosamente",
      });
      sessionStorage.clear()
    } catch (error) {
      console.log("error", error);
    } finally{
      setLoading(false);
    }
  };